<template>
  <el-dialog class="waterPump2"
      :visible="visible"
      :showClose="false"
      :modal="false"
      lock-scroll
      style="position: absolute"
  >
<!--水泵房一-->
    <!--动力柜- 消防泵控制器 -->
    <div class="firepump" v-if="parameter.firepump" >
      <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
      <img :src="firepumpImg" />
      <div style="">
        <div class="lights">
          <div class="light">
            <span>电源指示</span>
            <div class="greenbg">
              <span class="green"></span>
            </div>
          </div>
          <div class="light">
            <span>电源故障</span>
            <div class="yellowbg">
              <span class="grey"></span>
            </div>
          </div>
          <div class="light">
            <span>联动指示</span>
            <div class="redbg">
              <span class="grey"></span>
            </div>
          </div>
          <div class="light">
            <span>手动指示</span>
            <div class="greenbg">
              <span :class="parameter.class&&parameter.class.classshou?parameter.class.classshou:''" ref="shoudonglight"></span>
            </div>
          </div>
          <div class="light">
            <span>自动指示</span>
            <div class="greenbg">
              <span :class="parameter.class&&parameter.class.classzi?parameter.class.classzi:''" ref="zidonglight"></span>
            </div>
          </div>
          <div class="light ">
            <span>1主2备</span>
            <div @click="" class="greenbg">
              <span :class="parameter.class&&parameter.class.classzi2?parameter.class.classzi2:''" ref="zidonglight2"></span>
            </div>
          </div>
          <div class="light">
            <span>2主1备</span>
            <div class="greenbg">
              <span class="grey"></span>
            </div>
          </div>
        </div>
        <div class="pumplight">
          <div class="light">
            <span>1泵启动</span>
            <div class="redbg">
              <span v-if="parameter.class&&parameter.class.bengopen1" :class="parameter.class.bengopen1" ref="bengopen1"></span>
              <span v-else class="grey" ref="bengopen1" data-bb="grey"></span>
            </div>
          </div>
          <div class="light">
            <span>1泵故障</span>
            <div class="yellowbg">
              <span class="grey" :class="parameter.class.bengbad1" ref="bengbad1"></span>
            </div>
          </div>
          <div class="light">
            <span>2泵启动</span>
            <div class="redbg">
              <span v-if="parameter.class&&parameter.class.bengopen2" :class="parameter.class.bengopen2" ref="bengopen2"></span>
              <span v-else class="grey" ref="bengopen2"></span>
            </div>
          </div>
          <div class="light">
            <span>2泵故障</span>
            <div class="yellowbg">
              <span class="grey"></span>
            </div>
          </div>
          <div class="light">
            <span>水泵运行反馈</span>
            <div class="redbg"></div>
          </div>
        </div>
        <div class="buttons" v-if="parameter.buttonAns">
          <div v-for="(item,index) in parameter.buttonAns" class="button" @click="buttonSelect(item,$event)"></div>
        </div>
        <div class="fault" v-if="parameter.faultAns">
          <div v-for="(item,index) in parameter.faultAns" class="button" @click="buttonSelect(item,$event)"></div>
          <div class="button b1"></div>
        </div>
      </div>
    </div>
    <!--    动力柜-喷泵组电器柜-双电源自动转换开关-->
    <div class="conversion-switch" v-if="parameter.switch">
      <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
      <div class="bg-bottom"></div>
      <div class="rotate" :class="parameter.class&&parameter.class.rotate" ref="rotate" @click="buttonSelect('s2',$event)"></div>
      <div class="panel">
        <div class="operate">
          <div class="slight">
            <div class="group">
              <span  class="top  zidong" :class="parameter.class&&parameter.class.zidong"></span>
              <span class="bottom  zidong" :class="parameter.class&&parameter.class.zidong"></span>
            </div>
            <span >自动</span></div>
          <div class="button">
            <div class="inner" @click="buttonSelect('s1',$event)"></div>
          </div>
          <div class="slight">
            <div class="group">
              <span class="top shoudong" :class="parameter.class&&parameter.class.shoudong"></span>
              <span class="bottom shoudong" :class="parameter.class&&parameter.class.shoudong"></span>
            </div>
            <span >手动</span></div>
          <div class="light"><span class=""  :class="parameter.class&&parameter.class.dianlight"></span><span>电源</span></div>
          <div class="light"><span class="" :class="parameter.class&&parameter.class.zidonglight"></span><span>N合</span></div>
          <div class="light"><span class="" :class="parameter.class&&parameter.class.shoudonglight"></span><span>R合</span></div>
        </div>
        <div class="zhishi">
          <div class="point"  :class="parameter.class&&parameter.class.zhishideng" ref="zhishideng"></div>
        </div>
      </div>
    </div>

    <!--末端装置试水阀-->
    <div class="water-valve" v-if="parameter.waterValve">
      <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
      <img src="../../../assets/img/10/10-4-1-2.png" style="width: 35rem">

      <img class="bashou bashouzhuan"  v-if="parameter.water" src="../../../assets/img/10/10-4-12handle.png" @click="buttonSelect('waterbashou2')">
      <img class="bashou" v-else src="../../../assets/img/10/10-4-12handle.png" ref="bashou" @click="buttonSelect('waterbashou')">
      <img class="water" v-show="parameter.water" src="../../../assets/img/10/10-4-1-2water.png" ref="water">
    </div>
    <!--    湿式报警阀-警铃试验阀-->
    <div class="alarmBell1" v-if="parameter.alarmBell">
      <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
      <div class="alarmBellImg1">
        <img :src="alarmBellImg1">
      </div>
<!--      阀1 泄水阀-->
      <div class="bashou1" :class="parameter.class.bashou1" @click="buttonSelect('abbashou1')"></div>
<!--     阀2  警铃试验阀-->
      <div class="bashou2" :class="parameter.class.bashou2" @click="buttonSelect('abbashou2')"></div>
      <!--     阀3-->
      <div class="bashou3" :class="parameter.class.bashou3" @click="buttonSelect('abbashou3')"></div>
    </div>
    <!--    手动报警装置-->
    <div class="alarm" v-if="parameter.alarm">
      <img :src="zoomOutImg" class="zoomOut" @click="onClose"/>
      <img :src="alarmImg">
      <div class="quan" @click="buttonSelect('alarm1')"></div>
      <div class="" :class="parameter.class.dian"></div>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    parameter: {},
    close: {
      type: Function,
    },
  },
  data() {
    return {
      zoomOutImg:require('@/assets/img/zoomOut.png'),
      firepumpImg:require('@/assets/img/10/10-zidong.png'),
      alarmBellImg1:require('@/assets/img/wei10/10-3-2-1.jpg'),
      alarmImg:require('@/assets/img/wei10/10-3-2-2.png'),
      closeAudio:'magnifying-xiao.mp3',//弹窗关闭声音
      keyboardAudio:'keyboard.mp3',//按钮声音
      isShow: false,
    };
  },
  mounted() {
    // console.log(this.parameter)
  },
  created() {
    // console.log(this.parameter)
  },
  methods: {
    show() {
      this.isShow = true;
    },
    onClose() {
      this.close && this.close();
      this.$emit('customPlay2', this.closeAudio);
    },
    buttonSelect(value,e) {
      console.log('buttonSelect',value,this.parameter[value])
      if(this.parameter[value]){
        if(this.parameter[value]['up']&&(!this.parameter[value]['submit']||(this.parameter[value]['submit']&&(this.parameter[value]['submit']['equal']===1&&this.parameter.branchKey===this.parameter[value]['submit']['branch']||this.parameter[value]['submit']['equal']===3)))){
          let arr=this.parameter[value]['up'];
          let new_=this.arrcover(arr,this.parameter)
          this.$set(this.parameter,new_)
          console.log('buttonSelect-up',value)
        }
      }
      let submit=[];let update_=[];
      if(this.parameter[value]&&this.parameter[value]['submit']){
        submit=this.parameter[value]['submit'];
      }
      if(this.parameter[value]&&this.parameter[value]['update']){
        console.log('subUpdate1',this.parameter[value]['update'])
        update_= this.parameter[value]['update'];
      }

      this.$emit('customOther', value,submit,update_);
      this.$emit('customPlay2', this.keyboardAudio);
    },
    arrcover(arr,new_){
      Object.keys(arr).forEach((k)=>{
        if(typeof arr[k] === 'object'){
          if(!new_[k]){
            new_[k]={};
          }
          this.arrcover(arr[k],new_[k])
        }
        else{
          new_[k]=arr[k];
        }
      })
      return new_;
    },
  },
};
</script>

<style lang="less" scoped>
.el-dialog__wrapper {
  position: absolute;
}
.hiden {
  display: none !important;
}
/deep/.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1.875rem);
  max-width: calc(100% - 1.875rem);
  background: transparent;
  box-shadow: none;
  width: auto;
}

/deep/.el-dialog .el-dialog__body {
  max-height: 100%;
  flex: 1;
  -ms-flex: 1 1 auto;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
//动力柜- 消防泵控制器
.firepump1 {
  scale: 0.6;
  position: relative;
  .zoomOut {
    width: 2.8125rem;
    height: 2.8125rem;
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
  }
  .lights .light,
  .lights {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  }

  .lights {
    position: absolute;
    top: 7.403936%;
    left: 5.844156%;
    height: 15.182755%;
    width: 60.454545%;
    -ms-flex-align: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    background: #030508;
    .light {
      text-align: center;
      flex: 1;
      color: hsla(0, 0%, 100%, 0.8);
      font-size: 1.5625rem;
      font-weight: 700;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -ms-flex-align: center;
      div {
        display: inline-block;
        width: 4.75rem;
        height: 4.75rem;
        margin-top: 1.875rem;
        border-radius: 3.75rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        span {
          display: inline-block;
          width: 1.875rem;
          height: 1.875rem;
          border-radius: 1.875rem;
        }
        .green {
          background-color: #a7fd84;
        }
        .grey {
          background-color: #6a6a6a;
        }
      }
    }
  }
  .pumplight .light,
  .pumplight {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  }
  .pumplight {
    position: absolute;
    top: 58.950328%;
    left: 11.688312%;
    height: 14.151828%;
    width: 48.961039%;
    -ms-flex-align: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    background: #030508;
    .light {
      text-align: center;
      flex: 1;
      color: hsla(0, 0%, 100%, 0.8);
      font-size: 1.5625rem;
      font-weight: 700;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -ms-flex-align: center;
      div {
        width: 4.75rem;
        height: 4.75rem;
        margin-top: 1.875rem;
        border-radius: 3.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          display: inline-block;
          width: 1.875rem;
          height: 1.875rem;
          border-radius: 1.875rem;
        }
        .grey {
          background-color: #6a6a6a;
          font-size: 16px;
        }
        .red {
          background-color: #f64440;
        }

        .blink {
          animation: blink 1.5s linear;
        }
        @keyframes blink {
          0% {
            opacity: 0;
          }
          25% {
            opacity: 1;
          }
          50% {
            opacity: 0;
          }
          75% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }

        .yellow {
          background-color: #e7e002;
          opacity: 0;
        }
        .delay{
          animation: blink01 1s ease forwards;
          animation-delay: 5s;
        }
        .opacity0{
          opacity: 0;
        }
        @keyframes blink01 {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      }
    }
  }
  .greenbg {
    background: url(data:image/png;base64,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);
    background-size: 100% 100%;
  }
  .yellowbg {
    background: url(data:image/png;base64,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);
    background-size: 100% 100%;
  }
  .redbg {
    background: url(data:image/png;base64,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);
    background-size: 100% 100%;
  }

  .buttons {
    position: absolute;
    top: 35.895033%;
    left: 67.337662%;
    height: 33.833177%;
    width: 26.233766%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    .button {
      height: 9rem;
      width: 30%;
      margin-right: 5%;
      cursor: pointer;
    }
    .button:nth-of-type(3n + 3) {
      margin: 0;
    }
  }
  .fault {
    position: absolute;
    top: 79.100281%;
    left: 67.337662%;
    height: 11.715089%;
    width: 26.233766%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    .button {
      height: 6.625rem;
      width: 30%;
      margin-right: 5%;
      cursor: pointer;
    }
    .button:nth-of-type(3n + 3) {
      margin: 0;
    }
  }
}
.firepump {
  scale: 0.6;
  position: relative;
  .zoomOut {
    width: 2.8125rem;
    height: 2.8125rem;
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
  }
  .lights .light,
  .lights {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  }

  .lights {
    position: absolute;
    top: 7.403936%;
    left: 5.844156%;
    height: 15.182755%;
    width: 60.454545%;
    -ms-flex-align: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    background: #030508;
    .light {
      text-align: center;
      flex: 1;
      color: hsla(0, 0%, 100%, 0.8);
      font-size: 1.5625rem;
      font-weight: 700;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -ms-flex-align: center;
      div {
        display: inline-block;
        width: 4.75rem;
        height: 4.75rem;
        margin-top: 1.875rem;
        border-radius: 3.75rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        span {
          display: inline-block;
          width: 4.5rem;
          height: 4.5rem;
          border-radius: 4.5rem;
        }
        .green {
          background-color: #a7fd84;
        }
        .grey {
          background-color: #000;
        }
      }
    }
  }
  .pumplight .light,
  .pumplight {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  }
  .pumplight {
    position: absolute;
    top: 58.950328%;
    left: 11.688312%;
    height: 14.151828%;
    width: 48.961039%;
    -ms-flex-align: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    background: #030508;
    .light {
      text-align: center;
      flex: 1;
      color: hsla(0, 0%, 100%, 0.8);
      font-size: 1.5625rem;
      font-weight: 700;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      -ms-flex-align: center;
      div {
        width: 4.75rem;
        height: 4.75rem;
        margin-top: 1.875rem;
        border-radius: 3.75rem;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          display: inline-block;
          width: 4.5rem;
          height: 4.5rem;
          border-radius: 4.5rem;
        }
        .grey {
          background-color: #000;
        }
        .red {
          background-color: #f64440;
        }

        .blink {
          animation: blink 1.5s linear;
        }
        @keyframes blink {
          0% {
            opacity: 1;
          }
          25% {
            opacity: 1;
          }
          50% {
            opacity: 0;
          }
          75% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }

        .yellow {
          background-color: #e7e002;
        }
      }
    }
  }
  .greenbg {
    box-shadow: 0 0 0 1rem rgba(0 ,119,0.5);
  }
  .yellowbg {
    box-shadow: 0 0 0 1rem rgba(236 ,196 ,45,0.5);
  }
  .redbg {
    box-shadow: 0 0 0 1rem rgba(170, 6, 2);
  }

  .buttons {
    position: absolute;
    top: 35.895033%;
    left: 67.337662%;
    height: 33.833177%;
    width: 26.233766%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    .button {
      height: 9rem;
      width: 30%;
      margin-right: 5%;
      cursor: pointer;
    }
    .button:nth-of-type(3n + 3) {
      margin: 0;
    }
  }
  .fault {
    position: absolute;
    top: 79.100281%;
    left: 67.337662%;
    height: 11.715089%;
    width: 26.233766%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    .button {
      height: 6.625rem;
      width: 30%;
      margin-right: 5%;
      cursor: pointer;
    }
    .button:nth-of-type(3n + 3) {
      margin: 0;
    }
  }
}
//动力柜-双电源自动转换开关+
.conversion-switch{
  position: relative;
  background: -webkit-gradient(linear,left top,left bottom,from(#b0b6b4),to(#abb1ad));
  background: linear-gradient(#b0b6b4,#abb1ad);
  width: 57.1429rem;
  height: 54.9286rem;
  border: 8px solid #fff;
  border-radius: 16px;
  .zoomOut{
    right: 0.1rem;
    top: 0.5rem;
  }
  .panel {
    position: absolute;
    top: 18.699422%;
    left: 29.4%;
    height: 59.803468%;
    width: 41%;
    z-index: 999;
    background: url(../../../assets/img/10/10-3-1.png) no-repeat;
    background-size: 100% auto;
  }
  .rotate {
    position: absolute;
    background: url(../../../assets/img/10/10-3-2.png) no-repeat;
    top: 43.930636%;
    left: 18.7%;
    height: 19.653179%;
    width: 62.3%;
    background-size: 100% auto;
    background-position: 50%;
    -webkit-transform-origin: center center;
    transform-origin: center center;
    -webkit-transform: rotate(15deg);
    transform: rotate(15deg);
    -webkit-transition: -webkit-transform 1s linear;
    transition: -webkit-transform 1s linear;
    transition: transform 1s linear;
    transition: transform 1s linear, -webkit-transform 1s linear;
  }
  .rotate.zhuan {
    transform: rotate(-15deg);
  }
  .bg-bottom {
    position: absolute;
    width: 40rem;
    height: 24rem;
    background: url(../../../assets/img/10/10-3-3.png) no-repeat;
    background-size: 40rem 24rem;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .panel .operate {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 3.75rem;
    margin-top: .9375rem;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 1.875rem 0 1.875rem;
    font-size: .8125rem;
    font-weight: 800;
    margin-top: 7.1429rem
  }

  .panel .operate .slight .group,.panel .operate .slight {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
  }

  .panel .operate .slight .group {
    margin-bottom: .3125rem;
    width: 2.5rem;
    height: 1.875rem;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
  }

  .panel .operate .slight .group .top {
    width: .625rem;
    height: .625rem;
    background-color: #222
  }

  .panel .operate .slight .group .bottom {
    width: 1.875rem;
    height: .625rem;
    background-color: #222
  }

  .panel .operate .button {
    height: 3.125rem;
    width: 3.125rem;
    -webkit-box-shadow: 0 0 .1875rem #111,inset 0 0 .1875rem #111;
    box-shadow: 0 0 .1875rem #111,inset 0 0 .1875rem #111
  }

  .panel .operate .button .inner {
    background-color: #9b1e02;
    width: 2.5rem;
    height: 2.5rem;
    margin: .3125rem;
    border-radius: .1875rem;
    -webkit-box-shadow: 0 0 .1875rem #333,inset 1px 1px 0 hsla(0,0%,100%,.5);
    box-shadow: 0 0 .1875rem #333,inset 1px 1px 0 hsla(0,0%,100%,.5);
    cursor: pointer
  }

  .panel .operate .light {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
  }

  .panel .operate .light span:first-child {
    width: .75rem;
    height: .75rem;
    display: inline-block;
    margin-bottom: 1.3125rem
  }

  .panel .zhishi {
    position: absolute;
    left: 1.25rem;
    height: 9.6875rem;
    width: 6.25rem;
    bottom: 4.125rem
  }

  .panel .zhishi .point {
    width: 1.25rem;
    height: .5rem;
    background-color: #a52429;
    position: absolute
  }

  .panel .zhishi .point.top {
    -webkit-transform: skewX(-20deg);
    transform: skewX(-20deg);
    left: 2.925rem;
    top: 1.25rem
  }

  .panel .zhishi .point.bottom {
    -webkit-transform: skewX(20deg);
    transform: skewX(20deg);
    left: 2.875rem;
    bottom: 1.125rem
  }
  .panel .operate .light {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
  }
  .panel .operate .light span:first-child {
    width: .75rem;
    height: .75rem;
    display: inline-block;
    margin-bottom: 1.3125rem
  }

  .redlight{
    background-color: red!important
  }
  .greylight{
    background-color: #222!important
  }
  .red{
    background: red;
    border-radius: 5px;
    box-shadow: 0px 0px 5px red;
  }
  .grey{
    background: #6a6a6a;
    box-shadow: 0px 0px 5px #6a6a6a;
    border-radius: 5px;
  }
}

// 末端试水装置
.water-valve {
  background-color: #fff;
  border: 8px solid #fff;
  border-radius: 16px;
  position: relative;
  .zoomOut {
    width: 2.8125rem;
    height: 2.8125rem;
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
  }
  .bashou{
    cursor: pointer;
    position: absolute;
    left: 6.7rem;
    top: 16rem;
  }
  .bashouzhuan{
    transform: rotate(-90deg);
    transform-origin: 9rem center;
  }
  .water{
    height: 9.9375rem;
    position: absolute;
    top: 64.090805%;
    left: 41.3%;
  }
  .switch {
    top: 37.810345%;
    left: 24.5%;
    height: 3.466667%;
    width: 23.892108%;
    position: absolute;
    -webkit-transform-origin: 9rem center;
    transform-origin: 9rem center;
  }
  .switch.closed,
  .switch.open {
    -webkit-transition: -webkit-transform 0.5s linear;
    transition: -webkit-transform 0.5s linear;
    transition: transform 0.5s linear;
    transition: transform 0.5s linear, -webkit-transform 0.5s linear;
  }
  .switch.open {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
  .switch.anim-open {
    -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
  .switch.closed {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

.alarmBell1{
  position: relative;
  .zoomOut{
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
    position: absolute;
    right: 1rem;
    top: 1rem;
  }
  img{
    max-width: 55rem;
  }
  .alarmBellImg1{
    border: 0.5rem solid white;
    border-radius: 1rem;
  }
  .img1{

  }
  .bashou1{
    position: absolute;
    width: 5.5rem;
    height: 2rem;
    top: 20%;
    right: 46%;
    background: url(../../../assets/img/wei10/10-3-2-1-1.png) no-repeat ;
    background-size: 100% auto;
  }
  .bashou12{
    position: absolute;
    width: 1.2rem;
    height: 5rem;
    top: 22%;
    right: 45.1%;
    background: url(../../../assets/img/wei10/10-3-2-1-2.png) no-repeat ;
    background-size: 100% auto;
  }
  .bashou2{
    position: absolute;
    width: 5.5rem;
    height: 2rem;
    top: 46%;
    right: 59%;
    background: url(../../../assets/img/wei10/10-3-2-1-1.png) no-repeat ;
    background-size: 100% auto;
  }
  .bashou22{
    position: absolute;
    width: 1.2rem;
    height: 5rem;
    top: 47%;
    right: 58.3%;
    background: url(../../../assets/img/wei10/10-3-2-1-2.png) no-repeat ;
    background-size: 100% auto;
  }
  .bashou3{
    position: absolute;
    width: 5.5rem;
    height: 2rem;
    top: 59%;
    right: 41%;
    background: url(../../../assets/img/wei10/10-3-2-1-1.png) no-repeat ;
    background-size: 100% auto;
  }
  .bashou32{
    position: absolute;
    width: 1.2rem;
    height: 5rem;
    top: 59%;
    right: 40.5%;
    background: url(../../../assets/img/wei10/10-3-2-1-2.png) no-repeat ;
    background-size: 100% auto;
  }
}
//手动报警装置
.alarm{
  position: relative;
  .zoomOut{
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
    position: absolute;
    right: 1.25rem;
    top: 1.25rem;
  }
  img{
    width: 30rem;
  }
  .quan{
    position: absolute;
    top: 40.5%;
    left: 46%;
    width:2.5rem;
    height: 2.5rem;
    border-radius: 2rem;
    cursor: pointer;
  }
  .dian{
    position: absolute;
    top: 33.8%;
    left: 30.8%;
    //top: 11.7rem;
    //left: 9.2rem;
    border: 0.3809rem solid red;
    border-radius: 0.3809rem;
  }
}

</style>
